
export default {
    props: {
        supportEntry: {
            type: Object,
            default: null
        },
        donateUrl: {
            type: String,
            default: null,
        },
    }
};
